<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.stockplace_name" [ttModel]="setting.stockplace_name"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-12 p-5">
        <tt-tabs [(ttSelectedId)]="selectedBgStockCountResultMain">
            <tt-tab ttId="DETAILS" ttLabel="gb_stockcountresult_main_details"></tt-tab>
            <tt-tab ttId="LOCATIONS" ttLabel="gb_stockcountresult_main_locations"></tt-tab>
            <tt-tab ttId="VALUES" ttLabel="gb_stockcountresult_main_values"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-grid [hidden]="selectedBgStockCountResultMain !== 'DETAILS'" *ngIf="!!gridDetails" class="p-5 flex-1" [(ttOptions)]="gridDetails"></tt-grid>
    <tt-grid [hidden]="selectedBgStockCountResultMain !== 'LOCATIONS'" *ngIf="!!gridLocations" class="p-5 flex-1" [(ttOptions)]="gridLocations"></tt-grid>
    <tt-grid [hidden]="selectedBgStockCountResultMain !== 'VALUES'" *ngIf="!!gridValues" class="p-5 flex-1" [(ttOptions)]="gridValues"></tt-grid>

    <tt-card class="col-xs-12 col-md-12 p-5" *ngIf="setting.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
